import { CommonModule, NgOptimizedImage } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MAT_DATE_LOCALE, MatNativeDateModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MAT_DIALOG_DEFAULT_OPTIONS, MatDialogModule } from "@angular/material/dialog";
import { MatExpansionModule } from "@angular/material/expansion";
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatMenuModule } from "@angular/material/menu";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatSelectModule } from "@angular/material/select";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatSortModule } from "@angular/material/sort";
import { MatStepperModule } from "@angular/material/stepper";
import { MatTableModule } from "@angular/material/table";
import { NgxMaskDirective } from "ngx-mask";
import { NgxMatInputTelComponent } from "ngx-mat-input-tel";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { NgxSpinnerComponent } from "ngx-spinner";
import { FixNgxMatSelectSearchDirective } from "./shared/directives/ngx-mat-select-search-fix.directive";
import { TypeSafeMatCellDefDirective } from "./shared/directives/type-safe-mat-cell-def.directive";

@NgModule({
    imports: [
        NgOptimizedImage,
        NgxMatInputTelComponent,
        NgxSpinnerComponent,
        TypeSafeMatCellDefDirective,
        NgxMaskDirective,
        FixNgxMatSelectSearchDirective,
    ],
    exports: [
        CommonModule,
        MatAutocompleteModule,
        MatButtonModule,
        MatCardModule,
        MatCheckboxModule,
        MatDatepickerModule,
        MatDialogModule,
        MatExpansionModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatListModule,
        MatMenuModule,
        MatNativeDateModule,
        MatPaginatorModule,
        MatProgressSpinnerModule,
        MatSelectModule,
        MatSidenavModule,
        MatSortModule,
        MatStepperModule,
        MatTableModule,
        NgOptimizedImage,
        NgxMaskDirective,
        NgxMatInputTelComponent,
        NgxMatSelectSearchModule,
        NgxSpinnerComponent,
        ReactiveFormsModule,
        TypeSafeMatCellDefDirective,
        FixNgxMatSelectSearchDirective,
    ],
    providers: [
        { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: "outline", hideRequiredMarker: true } },
        { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { disableClose: true, autoFocus: false } },
        { provide: MAT_DATE_LOCALE, useValue: "en-GB" },
    ],
})
export class MaterialModule {}
